import { configureStore } from "@reduxjs/toolkit";
import {
  UserMetadataReducer,
  UserKeysReducer,
  UserBookmarksReducer,
  UserRelaysReducer,
  UserChatroomsReducer,
  UserChatContactsReducer,
  UserFollowingsReducer,
  UserMutedListReducer,
  UserBalanceReducer,
  UserFollowingsRelaysReducer,
  WalletsReducer,
  SelectedWalletReducer,
  UserAllRelaysReducer,
  UserInterestListReducer,
  UserSavedToolsReducer,
  UserAppSettingsReducer,
  UserFavRelaysReducer,
  UserWotListReducer,
  UserBlossomServersReducer,
  UserInboxRelaysReducer,
  UserFollowingsInboxRelaysReducer,
  IsUserFollowingsLoadedReducer,
  UserSearchRelaysReducer,
  UserRelaysSetReducer,
  UserPinnedNotesReducer,
  UserCashuWalletReducer,
  UserCashuTokensReducer,
  UserCashuHistoryReducer,
  UserNutZapsReducer,
  UserStarterPacksReducer,
  UserMediaPacksReducer,
} from "./Slides/UserData";
import {
  UserFirstLoginYakiChestReducer,
  IsConnectedToYakiReducer,
  YakiChestStatsReducer,
  IsYakiChestLoadedReducer,
  UpdatedActionFromYakiChestSliceReducer,
} from "./Slides/YakiChest";
import { NostrAuthorsReducer, NostrClientsReducer } from "./Slides/Profiles";
import {
  ToastReducer,
  ToPublishReducer,
  IsPublishingReducer,
} from "./Slides/Publishers";
import {
  IsDarkModeReducer,
  InitDMSReducer,
  FollowersCountSLReducer,
  ImportantFlashNewsReducer,
  TrendingUsersReducer,
  RecentTagsReducer,
  HomeSavedNotesReducer,
  HomeCarouselPostsReducer,
  RelaysStatsReducer,
  RefreshAppSettingsReducer,
  NotificationsReducer,
  IsNotificationsLoadingReducer,
  RefreshNotificationsReducer,
  VideoVolumeReducer,
} from "./Slides/Extras";

export const store = configureStore({
  reducer: {
    userMetadata: UserMetadataReducer,
    userKeys: UserKeysReducer,
    userBookmarks: UserBookmarksReducer,
    userRelays: UserRelaysReducer,
    userRelaysSet: UserRelaysSetReducer,
    userInterestList: UserInterestListReducer,
    userAllRelays: UserAllRelaysReducer,
    userChatrooms: UserChatroomsReducer,
    userChatContacts: UserChatContactsReducer,
    userFollowings: UserFollowingsReducer,
    userMutedList: UserMutedListReducer,
    userBalance: UserBalanceReducer,
    userFirstLoginYakiChest: UserFirstLoginYakiChestReducer,
    userSavedTools: UserSavedToolsReducer,
    userAppSettings: UserAppSettingsReducer,
    isConnectedToYaki: IsConnectedToYakiReducer,
    yakiChestStats: YakiChestStatsReducer,
    isYakiChestLoaded: IsYakiChestLoadedReducer,
    nostrAuthors: NostrAuthorsReducer,
    nostrClients: NostrClientsReducer,
    toast: ToastReducer,
    toPublish: ToPublishReducer,
    isPublishing: IsPublishingReducer,
    isDarkMode: IsDarkModeReducer,
    initDMS: InitDMSReducer,
    followersCountSL: FollowersCountSLReducer,
    updatedActionFromYakiChest: UpdatedActionFromYakiChestSliceReducer,
    userFollowingsRelays: UserFollowingsRelaysReducer,
    importantFlashNews: ImportantFlashNewsReducer,
    trendingUsers: TrendingUsersReducer,
    recentTags: RecentTagsReducer,
    wallets: WalletsReducer,
    selectedWallet: SelectedWalletReducer,
    userFavRelays: UserFavRelaysReducer,
    userInboxRelays: UserInboxRelaysReducer,
    userWotList: UserWotListReducer,
    userBlossomServers: UserBlossomServersReducer,
    userFollowingsInboxRelays: UserFollowingsInboxRelaysReducer,
    homeSavedNotes: HomeSavedNotesReducer,
    homeCarouselPosts: HomeCarouselPostsReducer,
    relaysStats: RelaysStatsReducer,
    isUserFollowingsLoaded: IsUserFollowingsLoadedReducer,
    refreshAppSettings: RefreshAppSettingsReducer,
    userSearchRelays: UserSearchRelaysReducer,
    notifications: NotificationsReducer,
    isNotificationsLoading: IsNotificationsLoadingReducer,
    refreshNotifications: RefreshNotificationsReducer,
    userPinnedNotes: UserPinnedNotesReducer,
    videoVolume: VideoVolumeReducer,
    userCashuWallet: UserCashuWalletReducer,
    userCashuTokens: UserCashuTokensReducer,
    userCashuHistory: UserCashuHistoryReducer,
    userNutZaps: UserNutZapsReducer,
    userStarterPacks: UserStarterPacksReducer,
    userMediaPacks: UserMediaPacksReducer,
  },
});
